import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-h-2 text-left qa-ss-title" }, "Session Setup", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SelectVerseList = _resolveComponent("SelectVerseList")!
  const _component_SelectVerseRange = _resolveComponent("SelectVerseRange")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    elevation: 4,
    class: "qa-session-setup"
  }, {
    default: _withCtx(() => [
      (_ctx.state !== 'selectVerseList')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "qa-ss-back-button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.state = 'selectVerseList'), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, { name: "arrow_back" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_1,
      (_ctx.state === 'selectVerseList')
        ? (_openBlock(), _createBlock(_component_SelectVerseList, {
            key: 1,
            onSelect: _ctx.selectVerseList
          }, null, 8, ["onSelect"]))
        : (_openBlock(), _createBlock(_component_SelectVerseRange, {
            key: 2,
            onSelect: _ctx.selectVerseRange
          }, null, 8, ["onSelect"]))
    ]),
    _: 1
  }))
}